import React from "react";
import ReactDOM from "react-dom/client";
import "animate.css";
import "./index.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import Home from "./pages/Home";
import BlogPage from "./pages/Blog";
import ContactPage from "./pages/Contact";
import AboutPage from "./pages/About";
import Services from "./pages/Services";
import SingleBlogPage from "./pages/SingleBlog";

const root = ReactDOM.createRoot(document.getElementById("root"));
const muiTheme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#52720D",
    },
    secondary: {
      main: "#758e3d",
    },

    text: {
      primary: "#191919",
      secondary: "#222222",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536,
    },
  },
  typography: {
    fontFamily: ["Inter", "-apple-system", "sans-serif"].join(","),
  },
  components: {
    MuiIcon: {
      styleOverrides: {
        root: {
          boxSizing: "content-box",
          padding: 3,
          fontSize: "1.125rem",
          color: "#000000",
          backgroundColor: "#000000",
        },
      },
    },
  },
});
root.render(
  <ThemeProvider theme={muiTheme}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/services/:service" element={<Services />}></Route>

        <Route path="/blog" element={<BlogPage />}></Route>
        <Route path="/blog/:blog" element={<SingleBlogPage />}></Route>
        <Route path="/contact" element={<ContactPage />}></Route>
        <Route path="/about" element={<AboutPage />}></Route>
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
);
